import { SPACING } from '@fedsim/constants'
import { makeStyles } from '@mui/styles'

export const useFooterStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: "100%",
    display: "flex",
    padding: theme.spacing(SPACING * 2),
    alignItems: "center",
    '& a': {
      color: theme.palette.primary.contrastText,
      textDecoration: 'underline',
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
  },
}))
